export default __webpack_public_path__ + "static/N0260-817b7779f007064d3e621c5a3d7d831b.png";